import { useMemo, useState } from 'react';

import { v4 } from 'uuid';

import { BodyEvStatesWithConsentMyPagesEiendomsverdieWithConsentPost, PartialCondominium, PartialHouse, PartialVacationHome } from 'src/api/zrm';
import { useApi } from 'src/contexts/APIContext';
import { useCustomerDataContext } from 'src/contexts/auth/CustomerDataContext';
import ContactData from 'src/types/auth/ContactData';

const useFetchEV = () => {
  const { api } = useApi();
  const { customerData, setCustomerData } = useCustomerDataContext();

  const [evDataLoading, setEvDataLoading] = useState(false);
  const [evDataLoaded, setEvDataLoaded] = useState(false);
  const [properties, setProperties] = useState<(PartialHouse | PartialCondominium | PartialVacationHome)[]>([]);

  const hasEmailAndPhone = useMemo(() => customerData?.email && customerData?.phone_number, [customerData]);

  const fetchEVData = useMemo(() => async (data?: ContactData) => {
    const requestId = v4();
    setEvDataLoading(true);

    let payload: BodyEvStatesWithConsentMyPagesEiendomsverdieWithConsentPost = { email: '', phone_number: '', marketing_consent: false };

    if (!hasEmailAndPhone) {
      payload = { email: data?.email, phone_number: data?.phone, marketing_consent: data?.marketingConsent };
    }

    try {
      const resp = await api.myPages.evStatesWithConsentMyPagesEiendomsverdieWithConsentPost(
        payload, { cancelToken: requestId, headers: { 'X-Request-ID': requestId } },
      );

      setProperties((resp.data.properties) || []);
      setCustomerData(resp.data.customer);
    } catch (e) {
      console.error(e);
    }

    setEvDataLoading(false);
    setEvDataLoaded(true);
  }, [api, hasEmailAndPhone]);


  return { evDataLoading, evDataLoaded, properties, fetchEVData };
};

export default useFetchEV;
